module.exports = __webpack_public_path__ + "static/media/palliatieve-zorg-vrouw-biedt-vrouw-zorg-en-hulp-large.8753a500.jpg";